export default function isSupport(property) {
  return property.substr(0, 9) === '@supports';
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-plugin-validator/node_modules/fela-utils/es/isSupport.js
// module id = 923
// module chunks = 0